import { call, put, select, takeEvery, fork, take, cancel } from 'redux-saga/effects';
import {
    POST_APPROVAL_CREATE,
    POST_APPROVAL_UPDATE,
    SET_POST_APPROVAL,
    GET_CTCANDCTI_FILE,
    POST_APPROVAL_LIST_FETCH,
    POST_APPROVAL_DETAIL_FETCH,
    POST_APPROVAL_LIST_FETCH_WITH_CANCEL,
    POST_APPROVAL_LIST_FETCH_COMPLETE,
} from 'store/key';
import { produce } from 'utility/general';
import api from 'api/call';
import { safeSaga } from 'store';
import { statusLookup } from 'utility/lookup';
import store from 'store';
import { setGlobal } from 'store/global/reducer';

const getInitialState = () => {
    return {
        draft: [],
        submit: [],
        review: [],
        ctcAndCtiSubmission: { ctcRespons: [], ctiRespons: [] },
        postApprovalDetail: {},
    };
};

function* createPostApprovalDocument(action) {
    const { postApproval } = yield select();
    const data = action.payload;
    postApproval.draft.push(data);

    yield put({
        type: SET_POST_APPROVAL,
        payload: postApproval,
    });
}

function* updatePostApproval(action) {
    // const state = getState().postApproval;

    const { postApproval } = yield select();
    const { postApprovalDocument, irbNo } = action.payload;

    //filter out dont need
    const filteredArray = postApproval.draft.filter((item, index) => {
        return item.irbNo !== irbNo;
    });

    postApproval.draft = [...filteredArray, ...postApprovalDocument];

    yield put({
        type: SET_POST_APPROVAL,
        payload: postApproval,
    });
}

function* fetchListWithCancel(action) {
    yield put({
        type: POST_APPROVAL_LIST_FETCH_COMPLETE,
        payload: {
            message: 'cancelled',
        },
    });

    const fetchCall = yield fork(fetchPostApprovalList, action);
    // wait for fetch complete
    const result = yield take(POST_APPROVAL_LIST_FETCH_COMPLETE);

    if (result?.payload?.message !== 'success') {
        yield cancel(fetchCall);
    }
}

function* fetchPostApprovalList(action) {
    try {
        const { page = 1, pageSize = 10, isDesc = true, sort = 'updateDtm', folder } = action.payload;

        yield put({
            type: SET_POST_APPROVAL,
            payload: {
                isLoading: true,
            },
        });

        const res = yield call(api.approval.getPostApprovalDocument, {
            page,
            pageSize,
            isDesc,
            sort,
            folder,
        });

        const { result } = res.data;
        const { result: data, ...rest } = result;

        // data.forEach((item) => (item.id = item.docId));

        yield put({
            type: SET_POST_APPROVAL,
            payload: {
                ...rest,
                data,
                sort,
                isDesc,
                folder,
            },
        });
    } catch (error) {
        console.log('120600 reducer.js error', error);
    }

    yield put({
        type: SET_POST_APPROVAL,
        payload: {
            isLoading: false,
        },
    });

    yield put({
        type: POST_APPROVAL_LIST_FETCH_COMPLETE,
        payload: {
            message: 'success',
        },
    });
}

function* getCTCAndCTIFile(action) {
    const { docType, reportId, callback, onPermissionError } = action.payload;
    let submission = {};
    try {
        const res = yield call(api.approval.getCTCAndCTIFile, { docType, reportId });

        const { result } = res.data;

        let subNo = null,
            statusDisplay = null;
        if (result.subNo) {
            subNo = result.subNo;
        }
        if (result.lastStatus !== null) {
            statusDisplay =
                statusLookup.find((item) => {
                    return result.lastStatus === item.key;
                })?.statusDisplay || null;
        }
        store.dispatch(
            setGlobal({
                postApprovalReportData: {
                    [reportId]: {
                        showNavigationSubNo: subNo,
                        showNavigationStatus: statusDisplay,
                    },
                },
            }),
        );

        submission = {
            ...result,
            oldData: {
                expiryDtm: result.expiryDtm,
                policyNo: result.policyNo,
                certNo: result.certNo,
            },
        };
    } catch (err) {
        console.log(err);

        return onPermissionError?.();
    }
    yield put({
        type: SET_POST_APPROVAL,
        payload: {
            ctcAndCtiSubmission: submission,
        },
    });
    callback?.();
}

function* fetchPostApprovalDetail(action) {
    try {
        yield put({
            type: SET_POST_APPROVAL,
            payload: {
                loadingDetail: true,
            },
        });

        const { type, id } = action.payload;
        const res = yield call(api.approval.getPostApprovalDocumentDetail, {
            type,
            id,
        });

        const { result } = res.data;
        yield put({
            type: SET_POST_APPROVAL,
            payload: {
                postApprovalDetail: result,
                loadingDetail: false,
            },
        });
    } catch (error) {
        throw error(error);
    }
    // setGlobalLoading(false);
}

const reducer = (state = getInitialState(), action) => {
    switch (action.type) {
        case SET_POST_APPROVAL:
            const newState = produce(state, (draft) => {
                Object.entries(action.payload).forEach(([key, value]) => {
                    draft[key] = action.payload[key];
                });
            });
            return newState;
        // case CLEAR_UP_REDUX:
        //     return getInitialState();
        default:
            return state;
    }
};

export function* watchPostApprovalDocument() {
    yield takeEvery(POST_APPROVAL_CREATE, safeSaga(createPostApprovalDocument));
    yield takeEvery(POST_APPROVAL_UPDATE, safeSaga(updatePostApproval));
    yield takeEvery(GET_CTCANDCTI_FILE, safeSaga(getCTCAndCTIFile));
    yield takeEvery(POST_APPROVAL_LIST_FETCH, safeSaga(fetchPostApprovalList));
    yield takeEvery(POST_APPROVAL_LIST_FETCH_WITH_CANCEL, safeSaga(fetchListWithCancel));
    yield takeEvery(POST_APPROVAL_DETAIL_FETCH, safeSaga(fetchPostApprovalDetail));
}

export default reducer;
